'use client';
import React from 'react';

interface HeroHeaderProps {
  title: string;
  subtitle: string;
  backgroundImageUrl?: string;
}

const HeroHeader = ({
  title,
  subtitle,
  backgroundImageUrl
}: HeroHeaderProps) => {
  const imageToUse = backgroundImageUrl || "https://images.pexels.com/photos/6596226/pexels-photo-6596226.jpeg";

  return (
    <div className="relative w-full h-[38vh] min-h-[260px] md:h-[380px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url("${imageToUse}")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'grayscale(55%) contrast(0.85) brightness(1.1)',
        }}
      />

      {/* Warm light overlay — slightly more opaque for readability */}
      <div className="absolute inset-0 z-10" style={{ background: 'linear-gradient(to bottom, rgba(242,237,228,0.90) 0%, rgba(242,237,228,0.82) 60%, rgba(242,237,228,0.95) 100%)' }} />

      {/* Subtle top border line */}
      <div className="absolute top-0 left-0 right-0 z-20 h-px bg-[#8C7B6B]/25" />

      {/* Text Content */}
      <div className="relative z-20 max-w-4xl mx-auto space-y-4 animate-scale-in px-6 text-center">
        <h1
          className="text-5xl md:text-6xl lg:text-7xl text-[#1A1614] tracking-wide drop-shadow-sm"
          style={{ fontFamily: 'Cormorant Garamond, Georgia, serif', fontWeight: 300, letterSpacing: '0.04em' }}
        >
          {title}
        </h1>

        <p className="text-[10px] md:text-xs font-sans text-[#4A4440] uppercase tracking-[0.35em] font-medium pt-1">
          {subtitle}
        </p>

        {/* Warm rule */}
        <div className="flex items-center justify-center gap-4 mt-5">
          <div className="w-12 h-px bg-[#8C7B6B]/40" />
          <div className="w-1 h-1 rounded-full bg-[#8C7B6B]/60" />
          <div className="w-12 h-px bg-[#8C7B6B]/40" />
        </div>
      </div>
    </div>
  );
};

export default HeroHeader;